import { useEffect } from 'react'
import { Link } from 'react-router-dom'

import Dialog from '../Dialog/index'
import { ReactComponent as ArrowBackIcon } from './arrow-back.svg'
import { ReactComponent as CloseIcon } from './close.svg'
import styles from './Dialog.module.scss'

const FormContainer = ({ handleConfirm, isButtonDisabled, children }) => {
  function handleSubmit(e) {
    e.preventDefault()
    if (!isButtonDisabled) {
      handleConfirm()
    }
  }

  return <form onSubmit={handleSubmit}>{children}</form>
}

const ConfirmationDialog = ({
  children,
  title,
  confirmLink,
  closeLink,
  onConfirm,
  onReject,
  negativeMessage,
  positiveMessage = 'OK',
  onClose,
  onBack,
  hasDangerousAction = false,
  theme,
  isButtonDisabled,
  isRejectButtonDisabled = false,
  actLikeForm,
  hasFixedTopMargin,
  onPressEnter,
  maxWidth = 480,
  titleIcon,
  hasCloseButton = true,
  hasConfirmButton = true,
  hasHeader = true,
  styleOverrides,
  contentPadding = '0 18px 24px',
  bottomBarDetail,
  allowOverflow = false,
  contentAbove,
  contentBelow
}) => {
  let dialogClass = styles.dialog

  if (theme === 'blacklist') {
    dialogClass += ` ${styles.blacklistTheme}`
  }

  if (hasFixedTopMargin) {
    dialogClass += ` ${styles.hasFixedPosition}`
  }
  useEffect(() => {
    function handlePressKeys(e) {
      const key = e.which || e.keyCode
      if (onPressEnter && key === 13 && !isButtonDisabled) {
        e.preventDefault()
        onPressEnter()
      }
      if (onClose && key === 27) {
        onClose()
        e.preventDefault()
      }
    }

    if (onPressEnter || onClose) {
      document.addEventListener('keydown', handlePressKeys)

      return () => document.removeEventListener('keydown', handlePressKeys)
    }
  }, [onPressEnter, onClose, isButtonDisabled])

  return (
    <Dialog>
      {contentAbove ? contentAbove : null}
      <div className={dialogClass} style={{ maxWidth, ...styleOverrides }}>
        {hasHeader && (
          <div className={styles.header}>
            {!!onBack && (
              <button className={styles.backButton} onClick={onBack}>
                <ArrowBackIcon title="back button" />
              </button>
            )}
            <div className={styles.dialogTitle}>
              {titleIcon && titleIcon} {title}
            </div>
            {hasCloseButton && (
              <>
                {closeLink ? (
                  <Link to={closeLink}>
                    <button className={styles.closeButton}>
                      <CloseIcon title="close button" />
                    </button>
                  </Link>
                ) : (
                  <button className={styles.closeButton} onClick={onClose || onReject}>
                    <CloseIcon title="close button" />
                  </button>
                )}
              </>
            )}
          </div>
        )}
        <div
          className={styles.content}
          style={{
            padding: contentPadding,
            overflow: allowOverflow ? 'visible' : 'auto'
          }}
        >
          {actLikeForm ? (
            <FormContainer isButtonDisabled={isButtonDisabled} handleConfirm={onConfirm}>
              {children}
            </FormContainer>
          ) : (
            <>{children}</>
          )}
        </div>
        {(hasConfirmButton || negativeMessage) && (
          <div className={styles.footer}>
            {bottomBarDetail && (
              <div className={styles.bottomBarDetail}>{bottomBarDetail}</div>
            )}
            {negativeMessage && (
              <Button onClick={onReject || onClose} disabled={isRejectButtonDisabled}>
                {negativeMessage}
              </Button>
            )}
            {hasConfirmButton && (
              <>
                {' '}
                {confirmLink ? (
                  <Link to={confirmLink}>
                    <Button primary>{positiveMessage}</Button>
                  </Link>
                ) : (
                  <Button
                    disabled={isButtonDisabled}
                    onClick={onConfirm || onClose}
                    primary
                    hasDangerousAction={hasDangerousAction}
                  >
                    {positiveMessage}
                  </Button>
                )}
              </>
            )}
          </div>
        )}
      </div>
      {contentBelow && contentBelow}
    </Dialog>
  )
}

const Button = ({ children, onClick, primary, hasDangerousAction, disabled = false }) => {
  let className

  if (primary && hasDangerousAction) {
    className = styles.dangerousPrimaryButton
  } else if (primary) {
    className = styles.primaryButton
  } else {
    className = styles.secondaryButton
  }

  return (
    <button disabled={disabled} className={className} onClick={onClick}>
      {children}
    </button>
  )
}

export default ConfirmationDialog
